module.exports = __webpack_public_path__ + "img/edit_64.4883adee.svg";